import permissions from '../../data/permissions';

export default [
    {
        name: "GeneralReceiptCreate",
        path: "general-receipt",
        component: () => import('./../../views/purchase/GeneralReceiptCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.general_receipt.create }
    },
    {
        name: "GeneralReceiptList",
        path: "general-receipts",
        component: () => import('./../../views/purchase/GeneralReceiptListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.general_receipt.index }
    },
    {
        name: "GeneralReceiptDisplay",
        path: "general-receipt/:id",
        component: () => import('./../../views/purchase/GeneralReceiptDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.general_receipt.read }
    },
    {
        name: "GeneralReceiptEdit",
        path: "general-receipt/:id/edit",
        component: () => import('./../../views/purchase/GeneralReceiptEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.general_receipt.update }
    }
]